import request from "@/request";
import {sortObjectAndStringify} from "../utils";


export const submitSubscription = data => {
 console.log(`logs => ${process.env.REACT_APP_SUBSCRIBE_API_URL}`)
 return request.post(process.env.REACT_APP_SUBSCRIBE_API_URL, {
  form_data: {
   ...data
  }
 });
};

// 邮箱订阅
export const GetSubscription = data => {
 const ruleForm = {
  ...data,
  timestamp: Math.floor(Date.now() / 1000)
 }

 return request.post('/subscriber', {
  ...ruleForm,
  sign: sortObjectAndStringify(ruleForm)
 })
}

// 提交
export const GetSubscriptTel = data => {
 const ruleForm = {
  ...data,
  timestamp: Math.floor(Date.now() / 1000)
 }

 return request.post('/contact', {
  ...ruleForm,
  sign: sortObjectAndStringify(ruleForm)
 })
}

// 获取实时数据
export const GetHomeMetrics = data => {
 const ruleForm = {
  timestamp: Math.floor(Date.now() / 1000)
 }

 return request.post('/metrics', {
  ...ruleForm,
  sign: sortObjectAndStringify(ruleForm)
 })
}

// 获取实时数据
export const GetStatics = data => {
 return request.get('https://api.llama.fi/tvl/vishwa')
}
